/****************************************************
 * Module Name:  sendToLabModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button, Tooltip } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import LabProxy from "../../utility/proxy/manager/labProxy";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

function SendToLabModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  sourceData,
  loading
}) {
  const [labData, SetLabData] = useState({
    lab: "",
    labOptions: [],
  });
  const [remark, setRemark] = useState("");
  const [labLoader, SetLabLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState(false);

  const prepareStoneData = () => {
    let stoneDataArray = [];
    sourceData.map((iData) => {
      if (stoneId.includes(iData.stoneid)) {
        if (!iData.pol) {
          setError(true);
          return true;
        }

        let obj = { stoneid: iData.stoneid, oldstatus: iData.status };
        stoneDataArray.push(obj);
      }
      return stoneDataArray;
    });
    return stoneDataArray;
  };

  useEffect(() => {
    getAllLabData();
  }, []);

  const getAllLabData = () => {
    SetLabLoader(true);
    LabProxy.GetAllLab((response) => {
      setDataLab(response);
      SetLabLoader(false);
    });
  };

  const setDataLab = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.name + " | " + data.location + " | " + data.country,
      };
      optionsArray.push(option);
      return true;
    });
    SetLabData({
      ...labData,
      labOptions: optionsArray,
      lab:
        labData.lab === "" && optionsArray.length > 0
          ? optionsArray[0]
          : labData.lab,
    });
  };

  const saveHandler = () => {
    let labId = labData.lab.value;
    let data = {
      userid: Constants.loggedInUser.id,
      remark: remark,
      stones: prepareStoneData(),
    };
    if (handleSave && stoneId.length === data.stones.length) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(labId, data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(labId, data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Send to lab validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        enforceFocus={false}
        centered
      >
        <TabMenuSnackbar
          show={error}
          message={"Mix Stone can not be sent to LAB."}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => setError(false)}
          title="Error"
        />
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Send To Lab
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box style={{ width: "8%" }}>
              <Form.Label>lab</Form.Label>
            </Box>
            <Box style={{ width: "92%" }}>
              <Select menuPlacement="auto"
                blurInputOnSelect={false}
                className="basic-single"
                classNamePrefix="select"
                value={labData.lab}
                isSearchable={true}
                name="lab"
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                options={labData.labOptions}
                onChange={(selectedOption) =>
                  SetLabData({
                    ...labData,
                    lab: selectedOption,
                  })
                }
              />
            </Box>
            <Box>
              {labLoader ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="large"
                    sx={{ cursor: "pointer" }}
                    onClick={getAllLabData}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            sx={{ mr: 3 }}
            startIcon={<SendRoundedIcon size="large" />}
            loading={loading}
            loadingPosition="start"
          >
            Send
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SendToLabModal;
